import { IssueOnSingleView } from 'components/dataProviders/withIssue/IssueOnSingleView';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { getWorkflowStoreState, findStagesByWorkflowId } from 'store/workflow';

export type IssueDeadlineFieldName =
  | IssueFieldNames.targetStartDate
  | IssueFieldNames.targetCompletionDate
  | IssueFieldNames.targetResponseToAuthorDate;

/**
 * Checks if the given stage is the last (final) stage in the workflow.
 * Uses the workflow store to look up the workflow and find the stage's position.
 */
export function isLastIssueStage(
  stageId: string | undefined,
  workflowId: string | undefined
): boolean {
  if (!stageId || !workflowId) {
    return false;
  }

  const { data } = getWorkflowStoreState();
  const stages = findStagesByWorkflowId(data.items, workflowId);

  if (!stages || stages.length === 0) {
    return false;
  }

  const lastStage = stages[stages.length - 1];
  return lastStage._id === stageId;
}

export function isPlannedStartDateStylingDisabled(
  row: IssueOnSingleView,
  fieldName: IssueDeadlineFieldName
): boolean {
  return (
    fieldName === IssueFieldNames.targetStartDate &&
    Boolean(row?.extendedData?.finalStartDate)
  );
}

export function isTargetCompletionDateStylingDisabled(
  row: IssueOnSingleView,
  fieldName: IssueDeadlineFieldName
): boolean {
  return (
    fieldName === IssueFieldNames.targetCompletionDate &&
    Boolean(row?.extendedData?.finalCompletionDate)
  );
}

export function isTargetResponseDateStylingDisabled(
  row: IssueOnSingleView,
  fieldName: IssueDeadlineFieldName
): boolean {
  return (
    fieldName === IssueFieldNames.targetResponseToAuthorDate &&
    Boolean(row?.extendedData?.finalResponseToAuthorDate)
  );
}
